import React from 'react';
import MainLayout from '@views/layouts/main-layout';
import { Block } from '@views/components/block';
import { NextSeo } from 'next-seo';

export const PolicyPage = () => (
  <MainLayout>
    <NextSeo title="Chính sách bảo mật" />
    <Block isSection>
      <Block.Header>
        <Block.Title heading as="h1">
          Chính sách bảo mật
        </Block.Title>
      </Block.Header>
      <Block.Body className="mt-4">
        <Block.Html>
          <p className="font-weight-bold">
            Quyền riêng tư của khách hàng vô cùng quan trọng với Văn Phòng Phẩm
            FAST, vì thế chúng tôi chỉ sử dụng thông tin cá nhân của quý khách
            vào những trường hợp nêu ra sau đây. Bảo vệ dữ liệu là vấn đề của sự
            tin tưởng và bảo mật danh tính của quý khách vô cùng quan trọng với
            chúng tôi. Vì thế, chúng tôi chỉ sẽ sử dụng tên và một số thông tin
            khác của quý khách theo cách được đề ra trong Chính sách Bảo mật
            này. Chúng tôi chỉ sẽ thu thập những thông tin cần thiết và có liên
            quan đến giao dịch giữa chúng tôi và quý khách.
          </p>
          <p>
            Chúng tôi chỉ giữ thông tin của quý khách trong thời gian luật pháp
            yêu cầu hoặc cho mục đích mà thông tin đó được thu thập. Quý khách
            có thể ghé thăm trang web mà không cần phải cung cấp bất kỳ thông
            tin cá nhân nào. Khi viếng thăm trang web, quý khách sẽ luôn ở trong
            tình trạng vô danh trừ khi quý khách có tài khoản trên trang web và
            đăng nhập vào bằng tên và mật khẩu của mình.
          </p>
          <p>
            Nếu quý khách có ý kiến hay đóng góp gì, xin vui lòng gửi đến địa
            chỉ email tới vanphongphamfast@gmail.com hoặc gọi đến hotline 0707 467 
            697. Chúng tôi luôn sẵn sàng lắng nghe nhận xét của quý khách.
          </p>
          <p>
            Quy định bảo mật của vanphongphamfast.com hoàn toàn tuân theo Nghị
            định 52/2013/NĐ-CP.
          </p>
          <Block.Title as="h3" className="mb-4">
            Thu thập thông tin cá nhân
          </Block.Title>
          <p>
            <em>Văn Phòng Phẩm FAST</em> không bán, chia sẻ hay trao đổi thông
            tin cá nhân của khách hàng thu thập trên trang web cho một bên thứ
            ba nào khác.
          </p>
          <p>
            Thông tin cá nhân thu thập được sẽ chỉ được sử dụng trong nội bộ
            công ty.
          </p>
          <p>
            Khi quý khách đăng ký tài khoản Văn Phòng Phẩm FAST, thông tin cá
            nhân mà chúng tôi thu thập bao gồm:
          </p>
          　
          <ul>
            <li>Tên</li>
            <li>Địa chỉ giao hàng</li>
            <li>Địa chỉ Email</li>
            <li>Số điện thoại di động</li>
            <li>Ngày sinh</li>
            <li>Giới tính</li>
          </ul>
          　
          <p>
            Những thông tin trên sẽ được sử dụng cho một hoặc tất cả các mục
            đích sau đây:
          </p>
          <ul>
            <li>Giao hàng quý khách đã mua tại vanphongphamfast.com</li>
            <li>Thông báo về việc giao hàng và hỗ trợ khách hàng</li>
            <li>Cung cấp thông tin liên quan đến sản phẩm</li>
            <li>
              Xử lý đơn đặt hàng và cung cấp dịch vụ và thông tin qua trang web
              của chúng tôi theo yêu cầu của quý khách
            </li>
            <li>
              Ngoài ra, chúng tôi sẽ sử dụng thông tin quý khách cung cấp để hỗ
              trợ quản lý tài khoản khách hàng; xác nhận và thực hiện các giao
              dịch tài chính liên quan đến các khoản thanh toán trực tuyến của
              quý khách; kiểm tra dữ liệu tải từ trang web của chúng tôi; cải
              thiện giao diện và/hoặc nội dung của các trang mục trên trang web
              và tùy chỉnh để dễ dàng hơn khi sử dụng; nhận diện khách đến thăm
              trang web; nghiên cứu về nhân khẩu học của người sử dụng; gửi đến
              quý khách thông tin mà chúng tôi nghĩ sẽ có ích hoặc do quý khách
              yêu cầu, bao gồm thông tin về sản phẩm và dịch vụ, với điều kiện
              quý khách đồng ý không phản đối việc được liên lạc cho các mục
              đích trên.
            </li>
          </ul>
          　
          <p>
            Chúng tôi có thể chia sẻ tên và địa chỉ của quý khách cho dịch vụ
            chuyển phát nhanh hoặc nhà cung cấp của chúng tôi để có thể giao
            hàng cho quý khách. Khi quý khách đăng ký làm thành viên trên trang
            website{' '}
            <a href="https://vanphongphamfast.com">vanphongphamfast.com</a>{' '}
            chúng tôi cũng sẽ sử dụng thông tin cá nhân của quý khách để gửi các
            thông tin khuyến mãi/tiếp thị. Quý khách có thể hủy nhận các thông
            tin đó bất kỳ lúc nào bằng cách sử dụng chức năng hủy đăng ký trong
            các thông báo quảng cáo. Chi tiết đơn hàng của quý khách sẽ được
            chúng tôi lưu trữ nhưng vì lý do bảo mật, quý khách không thể yêu
            cầu thông tin đó từ chúng tôi. Tuy nhiên, quý khách có thể kiểm tra
            thông tin đó bằng cách đăng nhập vào tài khoản riêng của mình trên
            trang web. Tại đó, quý khách có thể theo dõi đầy đủ chi tiết của các
            đơn hàng đã hoàn tất, những đơn hàng mở và những đơn hàng sắp được
            giao cũng như quản lý thông tin về địa chỉ, thông tin về ngân hàng
            và những bản tin mà quý khách đã đăng ký nhận. Quý khách cần bảo đảm
            là thông tin được truy cập một cách bí mật và không làm lộ cho một
            bên thứ ba không có quyền. Chúng tôi sẽ không chịu trách nhiệm đối
            với việc sử dụng sai mật khẩu trừ khi đó là lỗi của chúng tôi.
          </p>
          <Block.Title as="h3" className="mb-4">
            Cập nhật thông tin cá nhân
          </Block.Title>
          <p>
            Quý khách có thể cập nhật thông tin cá nhân của mình bất kỳ lúc nào
            bằng cách đăng nhập vào trang web{' '}
            <a href="https://vanphongphamfast.com">vanphongphamfast.com</a>.
          </p>
          <Block.Title as="h3" className="mb-4">
            Bảo mật thông tin cá nhân
          </Block.Title>
          <p>
            <em>Văn Phòng Phẩm FAST</em> đảm bảo rằng mọi thông tin thu thập
            được sẽ được lưu giữ an toàn. Chúng tôi bảo vệ thông tin cá nhân của
            quý khách bằng cách:{' '}
          </p>
          <ul>
            <li>
              Giới hạn truy cập thông tin cá nhân (chỉ khi đăng nhập quý khách
              mới thấy được thông tin cá nhân của mình).
            </li>
            <li>
              Sử dụng sản phẩm công nghệ để ngăn chặn truy cập máy tính trái
              phép.
            </li>
            <li>
              Xóa thông tin cá nhân của quý khách khi nó không còn cần thiết cho
              mục đích lưu trữ hồ sơ của chúng tôi.
            </li>
          </ul>
          　　
          <Block.Title as="h3" className="mb-4">
            Tiết lộ thông tin cá nhân
          </Block.Title>
          <p>
            Chúng tôi sẽ không chia sẻ thông tin của quý khách cho bất kỳ một
            công ty nào khác ngoại trừ những công ty và các bên thứ ba có liên
            quan trực tiếp đến việc giao hàng mà quý khách đã mua tại{' '}
            <a href="https://vanphongphamfast.com">vanphongphamfast.com</a>.
            Trong một vài trường hợp đặc biệt, <em>Văn Phòng Phẩm FAST</em> có
            thể bị yêu cầu phải tiết lộ thông tin cá nhân, ví dụ như khi có căn
            cứ cho việc tiết lộ thông tin là cần thiết để ngăn chặn các mối đe
            dọa về tính mạng và sức khỏe, hay cho mục đích thực thi pháp luật.
            Văn Phòng Phẩm FAST cam kết tuân thủ Đạo luật Bảo Mật và các Nguyên
            tắc Bảo mật Quốc gia. Nếu quý khách tin rằng bảo mật của quý khách
            bị <em>Văn Phòng Phẩm FAST</em> xâm phạm, xin vui lòng liên hệ với
            chúng tôi tại địa chỉ{' '}
            <a href="mailto:vanphongphamfast@gmail.com">
              vanphongphamfast@gmail.com
            </a>{' '}
            để được giải quyết vấn đề.
          </p>
          <Block.Title as="h3" className="mb-4">
            Thu thập dữ liệu máy tính
          </Block.Title>
          <p>
            Khi quý khách đến thăm vanphongphamfast.com, máy chủ của công ty
            chúng tôi sẽ tự động lưu trữ thông tin mà trình duyệt của quý khách
            gửi đến. Những thông tin này bao gồm:
          </p>
          　　{' '}
          <ul>
            <li>Địa chỉ IP của quý khách</li>
            <li>Loại trình duyệt</li>
            <li>
              Các trang web mà quý khách đã ghé thăm trước khi đến trang web của
              chúng tôi
            </li>
            <li>
              Những trang mục trong vanphongphamfast.com mà quý khách ghé thăm
            </li>
            <li>
              Khoảng thời gian quý khách giành ra đã xem những trang mục đó, sản
              phẩm, tìm kiếm thông tin trên trang web, thời gian và ngày tháng
              truy cập, và các số liệu thống kê khác.
            </li>
          </ul>
          　
          <p>
            Các thông tin đó được thu thập cho mục đích phân tích và đánh giá để
            góp phần cải thiện trang web, dịch vụ, và sản phẩm mà chúng tôi cung
            cấp. Những dữ liệu đó sẽ không có liên quan gì đến các thông tin cá
            nhân khác.{' '}
          </p>
          <Block.Title as="h3" className="mb-4">
            Thay đổi của Chính sách Bảo mật
          </Block.Title>
          <p>
            Văn Phòng Phẩm FAST có quyền thay đổi và chỉnh sửa Quy định Bảo mật
            vào bất kỳ lúc nào. Bất cứ thay đổi nào về chính sách này đều được
            đăng trên trang web của chúng tôi.
          </p>
          <p>
            Nếu quý khách không hài lòng với việc chúng tôi xử lý thắc mắc hay
            khiếu nại của quý khách, xin vui lòng liên hệ với chúng tôi tại{' '}
            <a href="mailto:vanphongphamfast@gmail.com">
              vanphongphamfast@gmail.com
            </a>{' '}
            hoặc hotline <a href="tel:0707 467 697">0707 467 697</a>
          </p>
        </Block.Html>
      </Block.Body>
    </Block>
  </MainLayout>
);

export default PolicyPage;
